export const data = {
  menus: [
    {
      id: "chickenator-team",
      name: "Team Mighty Chickenator",
      burger_id: "chickenator",
      second_position: {
        optional: false,
        items: ["harvest", "caesar", "stamina"],
      },
      third_position: {
        optional: true,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "protector-team",
      name: "Team Legendary Hamburger Protector",
      burger_included: true,
      burger_id: "protector",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "vigilante-team",
      name: "Team Incredible Vegan Vigilante",
      burger_included: true,
      burger_id: "vigilante",
      second_position: {
        optional: false,
        items: ["pal", "nugget", "harvest"],
      },
      third_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fourth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer"],
      },
      tags: ["menu"],
    },
    {
      id: "defender-team",
      name: "Team Classic Cheese Defender",
      burger_included: true,
      burger_id: "defender",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "titan-team",
      name: "Team Epic Angus Titan",
      burger_included: true,
      burger_id: "titan",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "fighter-team",
      name: "Team Supreme Chicken Fighter",
      burger_included: true,
      burger_id: "fighter",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "burgerman-team",
      name: "Team Amazing Burger-Man",
      burger_included: true,
      burger_id: "burgerman",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "bringer-team",
      name: "Team Fiery BBQ Bringer",
      burger_included: true,
      burger_id: "bringer",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "knight-team",
      name: "Team Supreme Baconator Knight",
      burger_included: true,
      burger_id: "knight",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
    {
      id: "avenger-team",
      name: "Team Infernal Chili Avenger",
      burger_included: true,
      burger_id: "avenger",
      second_position: {
        optional: false,
        items: ["pal", "master", "companion", "nugget", "renegate"],
      },
      third_position: {
        optional: true,
        items: ["harvest", "caesar", "stamina"],
      },
      fourth_position: {
        optional: true,
        items: ["bolt", "guardian", "dynamo", "burst"],
      },
      fifth_position: {
        optional: false,
        items: ["water", "soda", "juice", "beer", "milkshake"],
      },
      tags: ["menu"],
    },
  ],
  items: [
    {
      id: "chickenator",
      type: "burger",
      name: "The Mighty Chickenator",
      description:
        "Embark on an adventure fit for a superhero with our legendary Hero Burgers! Crafted from the finest ingredients and bursting with flavor, each burger is a bold testament to culinary greatness, guaranteed to satisfy even the mightiest of appetites. Join us in the quest for savory victory—try our Hero Burgers today!",
      ingredients: [
        "Chicken patty",
        "Tomatoes",
        "Lettuce",
        "Ketchup",
        "Mayo",
        "Sesam bun",
      ],
      price: 9.95,
      menu_price: 8.95,
      new: false,
      tags: ["burger", "chicken", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-mighty-chickenator-256-c.jpg",
          webp: "/img/burgers/256/the-mighty-chickenator-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-mighty-chickenator-700-c.jpg",
          webp: "/img/burgers/700/the-mighty-chickenator-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-mighty-chickenator-1200-c.jpg",
          webp: "/img/burgers/1200/the-mighty-chickenator-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-mighty-chickenator-2048-c.jpg",
          webp: "/img/burgers/2048/the-mighty-chickenator-2048.webp",
        },
      },
      weight: 290,
      nutrients_per_portion: {
        calories: 300,
        protein: 20,
        carbohydrates: 25,
        sugars: 3,
        fat: 13,
        fiber: 2,
        sodium: 0.3,
      },
    },
    {
      id: "protector",
      type: "burger",
      name: "The Legendary Hamburger Protector",
      description:
        "Behold the Legendary Hamburger Protector, a towering masterpiece that stands as a beacon of savory delight. Crafted from premium beef, nestled between fluffy brioche buns, and adorned with a symphony of fresh toppings, this burger is a symbol of taste and justice, ensuring every bite is an epic adventure!",
      ingredients: [
        "Beef patty",
        "Onions",
        "Pickles",
        "Tomatoes",
        "Lettuce",
        "Ketchup",
        "Mayo",
        "Brioche bun",
      ],
      price: 10.95,
      menu_price: 9.95,
      new: false,
      tags: ["burger", "beef", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-legendary-hamburger-protector-256-c.jpg",
          webp: "/img/burgers/256/the-legendary-hamburger-protector-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-legendary-hamburger-protector-700-c.jpg",
          webp: "/img/burgers/700/the-legendary-hamburger-protector-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-legendary-hamburger-protector-1200-c.jpg",
          webp: "/img/burgers/1200/the-legendary-hamburger-protector-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-legendary-hamburger-protector-2048-c.jpg",
          webp: "/img/burgers/2048/the-legendary-hamburger-protector-2048.webp",
        },
      },
      weight: 330,
      nutrients_per_portion: {
        calories: 300,
        protein: 18,
        carbohydrates: 23,
        sugars: 4,
        fat: 12,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "vigilante",
      type: "burger",
      name: "The Incredible Vegan Vigilante",
      description:
        "Unleash your inner hero with the Incredible Vegan Vigilante, a plant-powered burger that champions flavor and compassion. This burger fights for justice on your plate, proving that saving the world can be deliciously cruelty-free! Btw, haven't you heard yet? It's VEGAN!",
      ingredients: [
        "Vegan patty",
        "Lactose-free cheese",
        "Onions",
        "Pickles",
        "Tomatoes",
        "Lettuce",
        "Ketchup",
        "Vegan mayo",
        "Sesam bun",
      ],
      price: 11.95,
      menu_price: 10.95,
      new: false,
      tags: ["burger", "vegan"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-incredible-vegan-vigilante-256-c.jpg",
          webp: "/img/burgers/256/the-incredible-vegan-vigilante-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-incredible-vegan-vigilante-700-c.jpg",
          webp: "/img/burgers/700/the-incredible-vegan-vigilante-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-incredible-vegan-vigilante-1200-c.jpg",
          webp: "/img/burgers/1200/the-incredible-vegan-vigilante-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-incredible-vegan-vigilante-2048-c.jpg",
          webp: "/img/burgers/2048/the-incredible-vegan-vigilante-2048.webp",
        },
      },
      weight: 320,
      nutrients_per_portion: {
        calories: 230,
        protein: 15,
        carbohydrates: 18,
        sugars: 3,
        fat: 10,
        fiber: 2,
        sodium: 0.3,
      },
    },
    {
      id: "defender",
      type: "burger",
      name: "The Classic Cheese Defender",
      description:
        "Brace yourself for the ultimate comfort food experience with the Classic Cheese Defender—a timeless masterpiece that pays homage to the iconic cheeseburger. Sink your teeth into juicy beef, layered with melted cheese and crisp lettuce, all hugged by soft brioche buns — a savory shield against hunger's onslaught!",
      ingredients: [
        "Beef patty",
        "Cheese",
        "Lettuce",
        "Pickles",
        "Ketchup",
        "Mayo",
        "Brioche bun",
      ],
      price: 10.95,
      menu_price: 9.95,
      new: false,
      tags: ["burger", "beef", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-classic-cheese-defender-256-c.jpg",
          webp: "/img/burgers/256/the-classic-cheese-defender-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-classic-cheese-defender-700-c.jpg",
          webp: "/img/burgers/700/the-classic-cheese-defender-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-classic-cheese-defender-1200-c.jpg",
          webp: "/img/burgers/1200/the-classic-cheese-defender-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-classic-cheese-defender-2048-c.jpg",
          webp: "/img/burgers/2048/the-classic-cheese-defender-2048.webp",
        },
      },
      weight: 340,
      nutrients_per_portion: {
        calories: 300,
        protein: 16,
        carbohydrates: 21,
        sugars: 4,
        fat: 16,
        fiber: 2,
        sodium: 0.5,
      },
    },
    {
      id: "titan",
      type: "burger",
      name: "The Epic Angus Titan",
      description:
        "Prepare for a taste sensation like no other with the Epic Angus Titan - a burger of monumental proportions, forged from the finest Angus beef. With each bite, savor the rich, smoky flavor of premium beef, elevated by a symphony of fresh toppings - a true titan among burgers, destined for greatness!",
      ingredients: [
        "Angus beef",
        "Tomatoes",
        "Lettuce",
        "Pickles",
        "Red onions",
        "Mayo",
        "Brioche bun",
      ],
      price: 12.95,
      menu_price: 11.95,
      new: false,
      tags: ["burger", "beef", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-epic-angus-titan-256-c.jpg",
          webp: "/img/burgers/256/the-epic-angus-titan-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-epic-angus-titan-700-c.jpg",
          webp: "/img/burgers/700/the-epic-angus-titan-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-epic-angus-titan-1200-c.jpg",
          webp: "/img/burgers/1200/the-epic-angus-titan-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-epic-angus-titan-2048-c.jpg",
          webp: "/img/burgers/2048/the-epic-angus-titan-2048.webp",
        },
      },
      weight: 390,
      nutrients_per_portion: {
        calories: 320,
        protein: 22,
        carbohydrates: 23,
        sugars: 4,
        fat: 17,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "fighter",
      type: "burger",
      name: "The Supreme Chicken Fighter",
      description:
        "Join the battle against blandness with the Supreme Chicken Fighter, a grilled chicken burger that reigns supreme in flavor and satisfaction. Sink your teeth into tender, juicy chicken breast, grilled to perfection and nestled between soft ciabatta buns, ready to conquer any hunger with its savory charm!",
      ingredients: [
        "Grilled chicken",
        "Cheese",
        "Red peppers",
        "Rucola",
        "Ketchup",
        "Ciabatta bun",
      ],
      price: 10.55,
      menu_price: 9.55,
      new: false,
      tags: ["burger", "chicken", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-supreme-chicken-fighter-256-c.jpg",
          webp: "/img/burgers/256/the-supreme-chicken-fighter-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-supreme-chicken-fighter-700-c.jpg",
          webp: "/img/burgers/700/the-supreme-chicken-fighter-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-supreme-chicken-fighter-1200-c.jpg",
          webp: "/img/burgers/1200/the-supreme-chicken-fighter-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-supreme-chicken-fighter-2048-c.jpg",
          webp: "/img/burgers/2048/the-supreme-chicken-fighter-2048.webp",
        },
      },
      weight: 360,
      nutrients_per_portion: {
        calories: 200,
        protein: 24,
        carbohydrates: 15,
        sugars: 3,
        fat: 10,
        fiber: 2,
        sodium: 0.3,
      },
    },
    {
      id: "burgerman",
      type: "burger",
      name: "The Amazing Burger-Man",
      description:
        "Step into the culinary metropolis with the Amazing Burger-Man—a towering tribute to the iconic New Yorker. Featuring layers of premium beef, melted cheese, and a medley of fresh toppings, this burger swings into action to save your taste buds from boredom with each heroic bite!",
      ingredients: [
        "Beef patty",
        "Cheese",
        "Fried onions",
        "Pickles",
        "Lettuce",
        "Ketchup",
        "Mustard",
        "Brioche bun",
      ],
      price: 10.89,
      menu_price: 9.89,
      new: false,
      tags: ["burger", "beef", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-amazing-burger-man-256-c.jpg",
          webp: "/img/burgers/256/the-amazing-burger-man-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-amazing-burger-man-700-c.jpg",
          webp: "/img/burgers/700/the-amazing-burger-man-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-amazing-burger-man-1200-c.jpg",
          webp: "/img/burgers/1200/the-amazing-burger-man-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-amazing-burger-man-2048-c.jpg",
          webp: "/img/burgers/2048/the-amazing-burger-man-2048.webp",
        },
      },
      weight: 345,
      nutrients_per_portion: {
        calories: 300,
        protein: 15,
        carbohydrates: 20,
        sugars: 4,
        fat: 17,
        fiber: 2,
        sodium: 0.5,
      },
    },
    {
      id: "bringer",
      type: "burger",
      name: "The Fiery BBQ Bringer",
      description:
        "Ignite your taste buds with the Fiery BBQ Bringer, a burger that brings the heat and the flavor in equal measure. Featuring succulent beef, smothered in tangy BBQ sauce, and crowned with crispy onions, this burger is a fiery force to be reckoned with—a delicious explosion of taste that'll leave you craving more!",
      ingredients: [
        "Beef patty",
        "Lettuce",
        "Red onions",
        "Spicy jalapeños",
        "BBQ sauce",
        "Brioche bun",
      ],
      price: 11.85,
      menu_price: 10.85,
      new: true,
      tags: ["burger", "beef", "spicy"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-fiery-bbq-bringer-256-c.jpg",
          webp: "/img/burgers/256/the-fiery-bbq-bringer-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-fiery-bbq-bringer-700-c.jpg",
          webp: "/img/burgers/700/the-fiery-bbq-bringer-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-fiery-bbq-bringer-1200-c.jpg",
          webp: "/img/burgers/1200/the-fiery-bbq-bringer-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-fiery-bbq-bringer-2048-c.jpg",
          webp: "/img/burgers/2048/the-fiery-bbq-bringer-2048.webp",
        },
      },
      weight: 360,
      nutrients_per_portion: {
        calories: 350,
        protein: 20,
        carbohydrates: 24,
        sugars: 4,
        fat: 18,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "knight",
      type: "burger",
      name: "The Supreme Baconator Knight",
      description:
        "Embark on a flavor quest with the Supreme Baconator Knight, a burger fit for a hero of legendary proportions. Featuring juicy beef, crispy bacon, creamy ranch dressing, and fresh veggies, this burger wields its savory sword with unmatched culinary prowess—an epic feast fit for kings!",
      ingredients: [
        "Beef patty",
        "Roasted bacon",
        "Cheese",
        "Red onions",
        "Ranch dressing",
        "Brioche bun",
      ],
      price: 10.95,
      menu_price: 9.95,
      new: false,
      tags: ["burger", "beef", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-supreme-baconator-knight-256-c.jpg",
          webp: "/img/burgers/256/the-supreme-baconator-knight-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-supreme-baconator-knight-700-c.jpg",
          webp: "/img/burgers/700/the-supreme-baconator-knight-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-supreme-baconator-knight-1200-c.jpg",
          webp: "/img/burgers/1200/the-supreme-baconator-knight-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-supreme-baconator-knight-2048-c.jpg",
          webp: "/img/burgers/2048/the-supreme-baconator-knight-2048.webp",
        },
      },
      weight: 370,
      nutrients_per_portion: {
        calories: 400,
        protein: 25,
        carbohydrates: 20,
        sugars: 5,
        fat: 22,
        fiber: 2,
        sodium: 0.6,
      },
    },
    {
      id: "avenger",
      type: "burger",
      name: "The Infernal Chili Avenger",
      description:
        "Brace yourself for a flavor inferno with the Infernal Chili Avenger, a burger that ignites your taste buds with its fiery chili cheese goodness. Featuring smoky beef, spicy chili, melted cheese, and all the fixings, this burger delivers a flavor explosion that'll leave you feeling like a culinary superhero!",
      ingredients: [
        "Beef patty",
        "Onions",
        "Lettuce",
        "Spicy jalapeños",
        "Cheese sauce",
        "Sesam bun",
      ],
      price: 11.85,
      menu_price: 10.85,
      new: false,
      tags: ["burger", "beef", "spicy", "lactose"],
      image: {
        small: {
          jpg: "/img/burgers/256/the-infernal-chili-avenger-256-c.jpg",
          webp: "/img/burgers/256/the-infernal-chili-avenger-256.webp",
        },
        medium: {
          jpg: "/img/burgers/700/the-infernal-chili-avenger-700-c.jpg",
          webp: "/img/burgers/700/the-infernal-chili-avenger-700.webp",
        },
        large: {
          jpg: "/img/burgers/1200/the-infernal-chili-avenger-1200-c.jpg",
          webp: "/img/burgers/1200/the-infernal-chili-avenger-1200.webp",
        },
        original: {
          jpg: "/img/burgers/2048/the-infernal-chili-avenger-2048-c.jpg",
          webp: "/img/burgers/2048/the-infernal-chili-avenger-2048.webp",
        },
      },
      weight: 365,
      nutrients_per_portion: {
        calories: 300,
        protein: 17,
        carbohydrates: 20,
        sugars: 4,
        fat: 15,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "pal",
      type: "fingerfood",
      name: "Crispy Potato Pal",
      description:
        "Stand tall with the Crispy Potato Pal, a companion of unparalleled crunch and satisfaction. These golden fries, fried to perfection, accompany your meal like a loyal ally, ready to add a burst of flavor and texture to every heroic bite!",
      ingredients: [],
      price: 4.89,
      menu_price: 3.89,
      new: false,
      tags: ["fingerfood", "vegan"],
      image: {
        small: {
          jpg: "/img/fingerfood/256/crispy-potato-pal-256-c.jpg",
          webp: "/img/fingerfood/256/crispy-potato-pal-256.webp",
        },
        medium: {
          jpg: "/img/fingerfood/700/crispy-potato-pal-700-c.jpg",
          webp: "/img/fingerfood/700/crispy-potato-pal-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/fingerfood/2048/crispy-potato-pal-2048-c.jpg",
          webp: "/img/fingerfood/2048/crispy-potato-pal-2048.webp",
        },
      },
      weight: 180,
      nutrients_per_portion: {
        calories: 200,
        protein: 3,
        carbohydrates: 30,
        sugars: 1,
        fat: 15,
        fiber: 2,
        sodium: 0.3,
      },
    },
    {
      id: "master",
      type: "fingerfood",
      name: "Winged Master",
      description:
        "Take flight with the Winged Master, a sidekick that soars above the rest with its bold flavors and irresistible crunch. These succulent chicken wings, seasoned to perfection and coated in tangy sauce, are the ultimate wingman for any mealtime adventure!",
      ingredients: [],
      price: 6.85,
      menu_price: 5.85,
      new: false,
      tags: ["fingerfood", "chicken"],
      image: {
        small: {
          jpg: "/img/fingerfood/256/winged-master-256-c.jpg",
          webp: "/img/fingerfood/256/winged-master-256.webp",
        },
        medium: {
          jpg: "/img/fingerfood/700/winged-master-700-c.jpg",
          webp: "/img/fingerfood/700/winged-master-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/fingerfood/2048/winged-master-2048-c.jpg",
          webp: "/img/fingerfood/2048/winged-master-2048.webp",
        },
      },
      weight: 320,
      nutrients_per_portion: {
        calories: 250,
        protein: 20,
        carbohydrates: 8,
        sugars: 1,
        fat: 20,
        fiber: 0,
        sodium: 0.5,
      },
    },
    {
      id: "companion",
      type: "fingerfood",
      name: "Nugget Companion",
      description:
        "Join forces with the Nugget Companion, a sidekick that brings a touch of whimsy and flavor to every meal. These crispy chicken nuggets, tender and delicious, stand by your side like a loyal friend, ready to add a dose of fun and satisfaction to your culinary escapades!",
      ingredients: [],
      price: 5.89,
      menu_price: 4.89,
      new: false,
      tags: ["fingerfood", "chicken"],
      image: {
        small: {
          jpg: "/img/fingerfood/256/nugget-companion-256-c.jpg",
          webp: "/img/fingerfood/256/nugget-companion-256.webp",
        },
        medium: {
          jpg: "/img/fingerfood/700/nugget-companion-700-c.jpg",
          webp: "/img/fingerfood/700/nugget-companion-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/fingerfood/2048/nugget-companion-2048-c.jpg",
          webp: "/img/fingerfood/2048/nugget-companion-2048.webp",
        },
      },
      weight: 225,
      nutrients_per_portion: {
        calories: 200,
        protein: 10,
        carbohydrates: 16,
        sugars: 1,
        fat: 17,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "nugget",
      type: "fingerfood",
      name: "Cruelty-Free Nugget",
      description:
        "Embrace compassion with the Cruelty-Free Nugget, a companion that champions flavor and kindness in equal measure. These vegan nuggets, crafted from wholesome ingredients and bursting with savory goodness, stand as a testament to the power of plant-based eating—a delicious ally in your quest for culinary greatness!",
      ingredients: [],
      price: 6.89,
      menu_price: 5.89,
      new: false,
      tags: ["fingerfood", "vegan"],
      image: {
        small: {
          jpg: "/img/fingerfood/256/cruelty-free-nugget-256-c.jpg",
          webp: "/img/fingerfood/256/cruelty-free-nugget-256.webp",
        },
        medium: {
          jpg: "/img/fingerfood/700/cruelty-free-nugget-700-c.jpg",
          webp: "/img/fingerfood/700/cruelty-free-nugget-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/fingerfood/2048/cruelty-free-nugget-2048-c.jpg",
          webp: "/img/fingerfood/2048/cruelty-free-nugget-2048.webp",
        },
      },
      weight: 200,
      nutrients_per_portion: {
        calories: 150,
        protein: 7,
        carbohydrates: 17,
        sugars: 1,
        fat: 11,
        fiber: 3,
        sodium: 0.4,
      },
    },
    {
      id: "renegate",
      type: "fingerfood",
      name: "Ringed Renegade",
      description:
        "Prepare for a culinary revolution with the Ringed Renegade, a sidekick that defies convention and delights the senses. These crispy onion rings, golden and irresistible, add a touch of rebellion to any meal, standing as a symbol of flavor and fun in a world of ordinary sides!",
      ingredients: [],
      price: 4.55,
      menu_price: 3.55,
      new: false,
      tags: ["fingerfood"],
      image: {
        small: {
          jpg: "/img/fingerfood/256/ringed-renegate-256-c.jpg",
          webp: "/img/fingerfood/256/ringed-renegate-256.webp",
        },
        medium: {
          jpg: "/img/fingerfood/700/ringed-renegate-700-c.jpg",
          webp: "/img/fingerfood/700/ringed-renegate-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/fingerfood/2048/ringed-renegate-2048-c.jpg",
          webp: "/img/fingerfood/2048/ringed-renegate-2048.webp",
        },
      },
      weight: 260,
      nutrients_per_portion: {
        calories: 250,
        protein: 2,
        carbohydrates: 25,
        sugars: 2,
        fat: 5,
        fiber: 2,
        sodium: 0.4,
      },
    },
    {
      id: "harvest",
      type: "salad",
      name: "Plant-Powered Harvest",
      description:
        "A vegan salad packed with nutrient-rich vegetables to fortify your body and mind.",
      ingredients: [
        "Lettuce leafs",
        "Cherry tomatoes",
        "Carrots",
        "Cucumbers",
        "Sunflower seeds",
        "Balsamic dressing",
      ],
      price: 4.89,
      menu_price: 3.89,
      new: false,
      tags: ["salad", "vegan"],
      image: {
        small: {
          jpg: "/img/salads/256/plant-powered-harvest-256-c.jpg",
          webp: "/img/salads/256/plant-powered-harvest-256.webp",
        },
        medium: {
          jpg: "/img/salads/700/plant-powered-harvest-700-c.jpg",
          webp: "/img/salads/700/plant-powered-harvest-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/salads/2048/plant-powered-harvest-2048-c.jpg",
          webp: "/img/salads/2048/plant-powered-harvest-2048.webp",
        },
      },
      weight: 330,
      nutrients_per_portion: {
        calories: 100,
        protein: 2,
        carbohydrates: 10,
        sugars: 5,
        fat: 5,
        fiber: 3,
        sodium: 0.1,
      },
    },
    {
      id: "caesar",
      type: "salad",
      name: "Caesar's Conqueror Crisp",
      description:
        "A Caesar salad with a heroic twist, featuring crisp romaine lettuce, tangy Caesar dressing, and savory toppings fit for a conqueror.",
      ingredients: [
        "Lettuce leafs",
        "Croutons",
        "Cheese",
        "Cherry tomatoes",
        "Caesar dressing",
      ],
      price: 5.65,
      menu_price: 4.65,
      new: false,
      tags: ["salad", "lactose"],
      image: {
        small: {
          jpg: "/img/salads/256/caesars-conqueror-crisp-256-c.jpg",
          webp: "/img/salads/256/caesars-conqueror-crisp-256.webp",
        },
        medium: {
          jpg: "/img/salads/700/caesars-conqueror-crisp-700-c.jpg",
          webp: "/img/salads/700/caesars-conqueror-crisp-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/salads/2048/caesars-conqueror-crisp-2048-c.jpg",
          webp: "/img/salads/2048/caesars-conqueror-crisp-2048.webp",
        },
      },
      weight: 230,
      nutrients_per_portion: {
        calories: 150,
        protein: 7,
        carbohydrates: 10,
        sugars: 3,
        fat: 15,
        fiber: 2,
        sodium: 0.3,
      },
    },
    {
      id: "stamina",
      type: "salad",
      name: "Chicken Stamina Salad",
      description:
        "A chicken salad fit for a champion, featuring tender chicken breast, crisp vegetables, and a dressing that reigns supreme.",
      ingredients: [
        "Chicken filet",
        "Lettuce leafs",
        "Cheese",
        "Cherry tomatoes",
        "Olive oil",
      ],
      price: 5.95,
      menu_price: 4.95,
      new: false,
      tags: ["salad", "chicken"],
      image: {
        small: {
          jpg: "/img/salads/256/chicken-stamina-salad-256-c.jpg",
          webp: "/img/salads/256/chicken-stamina-salad-256.webp",
        },
        medium: {
          jpg: "/img/salads/700/chicken-stamina-salad-700-c.jpg",
          webp: "/img/salads/700/chicken-stamina-salad-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/salads/2048/chicken-stamina-salad-2048-c.jpg",
          webp: "/img/salads/2048/chicken-stamina-salad-2048.webp",
        },
      },
      weight: 275,
      nutrients_per_portion: {
        calories: 200,
        protein: 16,
        carbohydrates: 10,
        sugars: 3,
        fat: 10,
        fiber: 2,
        sodium: 0.2,
      },
    },
    {
      id: "bolt",
      type: "dessert",
      name: "Fudgy Power Bolt",
      description:
        "Indulge in the Fudgy Power Bolt, a brownie bursting with chocolaty goodness that fuels you with the energy to conquer any challenge with its rich and decadent flavor!",
      ingredients: [],
      price: 4.89,
      menu_price: 3.89,
      new: false,
      tags: ["dessert"],
      image: {
        small: {
          jpg: "/img/desserts/256/the-fudgy-power-bolt-256-c.jpg",
          webp: "/img/desserts/256/the-fudgy-power-bolt-256.webp",
        },
        medium: {
          jpg: "/img/desserts/700/the-fudgy-power-bolt-700-c.jpg",
          webp: "/img/desserts/700/the-fudgy-power-bolt-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/desserts/2048/the-fudgy-power-bolt-2048-c.jpg",
          webp: "/img/desserts/2048/the-fudgy-power-bolt-2048.webp",
        },
      },
      weight: 75,
      nutrients_per_portion: {
        calories: 400,
        protein: 6,
        carbohydrates: 45,
        sugars: 27,
        fat: 20,
        fiber: 3,
        sodium: 0.2,
      },
    },
    {
      id: "guardian",
      type: "dessert",
      name: "Creamy Fortress Guardian",
      description:
        "Delight in the Creamy Fortress Guardian, a cheesecake masterpiece that fortifies your spirit with its velvety texture and rich flavors, granting you the strength to defend against any adversity!",
      ingredients: [],
      price: 5.38,
      menu_price: 4.38,
      new: false,
      tags: ["dessert", "lactose"],
      image: {
        small: {
          jpg: "/img/desserts/256/the-creamy-fortress-guardian-256-c.jpg",
          webp: "/img/desserts/256/the-creamy-fortress-guardian-256.webp",
        },
        medium: {
          jpg: "/img/desserts/700/the-creamy-fortress-guardian-700-c.jpg",
          webp: "/img/desserts/700/the-creamy-fortress-guardian-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/desserts/2048/the-creamy-fortress-guardian-2048-c.jpg",
          webp: "/img/desserts/2048/the-creamy-fortress-guardian-2048.webp",
        },
      },
      weight: 90,
      nutrients_per_portion: {
        calories: 300,
        protein: 8,
        carbohydrates: 25,
        sugars: 20,
        fat: 20,
        fiber: 2,
        sodium: 0.2,
      },
    },
    {
      id: "dynamo",
      type: "dessert",
      name: "Choco-Chip Dynamo",
      description:
        "Energize yourself with the Choco-Chip Dynamo, a chocolate cookie packed with sweet surprises and crunchy goodness, unleashing a burst of energy that propels you to superhero heights with every bite!",
      ingredients: [],
      price: 2.89,
      menu_price: 1.89,
      new: false,
      tags: ["dessert"],
      image: {
        small: {
          jpg: "/img/desserts/256/the-choco-chip-dynamo-256-c.jpg",
          webp: "/img/desserts/256/the-choco-chip-dynamo-256.webp",
        },
        medium: {
          jpg: "/img/desserts/700/the-choco-chip-dynamo-700-c.jpg",
          webp: "/img/desserts/700/the-choco-chip-dynamo-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/desserts/2048/the-choco-chip-dynamo-2048-c.jpg",
          webp: "/img/desserts/2048/the-choco-chip-dynamo-2048.webp",
        },
      },
      weight: 75,
      nutrients_per_portion: {
        calories: 450,
        protein: 6,
        carbohydrates: 55,
        sugars: 40,
        fat: 25,
        fiber: 3,
        sodium: 0.3,
      },
    },
    {
      id: "burst",
      type: "dessert",
      name: "Mighty Berry Burst",
      description:
        "Fuel your adventures with the Mighty Berry Burst, a muffin loaded with juicy berries and wholesome ingredients, empowering you with a burst of vitality and flavor that propels you forward on your heroic journey!",
      ingredients: [],
      price: 4.89,
      menu_price: 3.89,
      new: false,
      tags: ["dessert", "lactose"],
      image: {
        small: {
          jpg: "/img/desserts/256/the-mighty-berry-burst-256-c.jpg",
          webp: "/img/desserts/256/the-mighty-berry-burst-256.webp",
        },
        medium: {
          jpg: "/img/desserts/700/the-mighty-berry-burst-700-c.jpg",
          webp: "/img/desserts/700/the-mighty-berry-burst-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "/img/desserts/2048/the-mighty-berry-burst-2048-c.jpg",
          webp: "/img/desserts/2048/the-mighty-berry-burst-2048.webp",
        },
      },
      weight: 130,
      nutrients_per_portion: {
        calories: 250,
        protein: 4,
        carbohydrates: 40,
        sugars: 15,
        fat: 13,
        fiber: 3,
        sodium: 0.2,
      },
    },
    {
      id: "water",
      type: "drink",
      name: "Sparkling Water",
      description: "Rejuvenate with the Bubbly Vitality Elixir!",
      ingredients: [],
      price: 2.59,
      menu_price: 1.59,
      new: false,
      tags: ["drink"],
      image: {
        small: {
          jpg: "/img/drinks/256/sparkling-water-256-c.jpg",
          webp: "/img/drinks/256/sparkling-water-256.webp",
        },
        medium: {
          jpg: "/img/drinks/700/sparkling-water-700-c.jpg",
          webp: "/img/drinks/700/sparkling-water-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "",
          webp: "",
        },
      },
      weight: 500,
      nutrients_per_portion: {
        calories: 0,
        protein: 0,
        carbohydrates: 0,
        sugars: 0,
        fat: 0,
        fiber: 0,
        sodium: 0,
      },
    },
    {
      id: "soda",
      type: "drink",
      name: "Soda",
      description: "Energize yourself with the Fizzy Power Surge!",
      ingredients: [],
      price: 3.55,
      menu_price: 2.55,
      new: false,
      tags: ["drink"],
      image: {
        small: {
          jpg: "/img/drinks/256/soda-256-c.jpg",
          webp: "/img/drinks/256/soda-256.webp",
        },
        medium: {
          jpg: "/img/drinks/700/soda-700-c.jpg",
          webp: "/img/drinks/700/soda-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "",
          webp: "",
        },
      },
      weight: 500,
      nutrients_per_portion: {
        calories: 50,
        protein: 0,
        carbohydrates: 10,
        sugars: 10,
        fat: 0,
        fiber: 0,
        sodium: 0.02,
      },
    },
    {
      id: "juice",
      type: "drink",
      name: "Juice",
      description: "Revitalize with the Fruit-Fueled Dynamo!",
      ingredients: [],
      price: 3.89,
      menu_price: 2.89,
      new: false,
      tags: ["drink"],
      image: {
        small: {
          jpg: "/img/drinks/256/juice-256-c.jpg",
          webp: "/img/drinks/256/juice-256.webp",
        },
        medium: {
          jpg: "/img/drinks/700/juice-700-c.jpg",
          webp: "/img/drinks/700/juice-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "",
          webp: "",
        },
      },
      weight: 500,
      nutrients_per_portion: {
        calories: 60,
        protein: 0,
        carbohydrates: 15,
        sugars: 15,
        fat: 0,
        fiber: 0,
        sodium: 0.01,
      },
    },
    {
      id: "beer",
      type: "drink",
      name: "Beer",
      description: "Unwind with the Brewed Resilience Beverage!",
      ingredients: [],
      price: 5.59,
      menu_price: 4.59,
      new: false,
      tags: ["drink", "alcoholic"],
      image: {
        small: {
          jpg: "/img/drinks/256/beer-256-c.jpg",
          webp: "/img/drinks/256/beer-256.webp",
        },
        medium: {
          jpg: "/img/drinks/700/beer-700-c.jpg",
          webp: "/img/drinks/700/beer-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "",
          webp: "",
        },
      },
      weight: 500,
      nutrients_per_portion: {
        calories: 50,
        protein: 0,
        carbohydrates: 5,
        sugars: 15,
        fat: 0,
        fiber: 0,
        sodium: 0.01,
      },
    },
    {
      id: "milkshake",
      type: "drink",
      name: "Milkshake",
      description: "Indulge in the Creamy Power Potion!",
      ingredients: [],
      price: 4.99,
      menu_price: 3.99,
      new: false,
      tags: ["drink", "lactose"],
      image: {
        small: {
          jpg: "/img/drinks/256/milkshake-256-c.jpg",
          webp: "/img/drinks/256/milkshake-256.webp",
        },
        medium: {
          jpg: "/img/drinks/700/milkshake-700-c.jpg",
          webp: "/img/drinks/700/milkshake-700.webp",
        },
        large: {
          jpg: "",
          webp: "",
        },
        original: {
          jpg: "",
          webp: "",
        },
      },
      weight: 400,
      nutrients_per_portion: {
        calories: 250,
        protein: 5,
        carbohydrates: 30,
        sugars: 25,
        fat: 10,
        fiber: 0,
        sodium: 0.1,
      },
    },
  ],
};
